var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../abstracts/colors';
var ChevronSvg = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  width: 1.5rem;\n  height: 1.5rem;\n  top: calc(50% - 0.75rem);\n  right: 1rem;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  width: 1.5rem;\n  height: 1.5rem;\n  top: calc(50% - 0.75rem);\n  right: 1rem;\n  pointer-events: none;\n"])));
export var Chevron = function (props) { return (React.createElement(ChevronSvg, __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.41 7.99991L12 13L16.59 7.99991L18 9.40991L12 15.4099L6 9.40991L7.41 7.99991Z", fill: colors.black }))); };
var templateObject_1;
